import { ComponentSpinner } from "@components/spinner";
import { useTranslation } from "react-i18next";
import { Badge, CardBody } from "reactstrap";

const FilePreview = (props) => {
    const { attachmentResponse, loading } = props;
    const { t } = useTranslation();

    const getFileURL = (file) => {
        let type = "other";
        if (file.mimeType.startsWith("image/")) {
            type = "image";
        } else if (file.mimeType === "application/pdf") {
            type = "pdf";
        }

        const byteCharacters = atob(file.content.split(",")[1]);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: file.mimeType });
        const fileURL = URL.createObjectURL(blob);

        return { type, url: fileURL };
    };

    return loading ? (
        <ComponentSpinner height="100px"/>
    ) : (
        <CardBody className="d-flex flex-column align-items-center my-2">
            {attachmentResponse.map((res) => {
                return res.attachments.map((attach, index) => {
                    const { type, url } = getFileURL(attach);
                    let content = <a href={url}>{t("Download File")}</a>;
                    if (type === "image") {
                        content = (
                            <a href={url} target="_blank" rel="noopener noreferrer">
                                <img
                                    src={attach.content}
                                    alt={attach.filename}
                                    className="object-contain w-full h-full"/>
                            </a>
                        );
                    } else if (type === "pdf") {
                        content = <iframe src={url} height="400px" />;
                    }
                    return (
                        <div className="d-flex w-100 align-items-center flex-column border mt-1 p-1">
                            <Badge color="primary align-self-start">File #{index}</Badge>
                            {content}
                        </div>
                    );
                });
            })}
        </CardBody>
    );
};

export default FilePreview;